// extracted by mini-css-extract-plugin
export var twitterBg = "Share-module--twitterBg--7HVn3";